import { Component } from "react";
// import PropTypes from "prop-types";
import Button, { ButtonProps } from "reactstrap/lib/Button";
import Spinner from "./Spinner";
import _ from "lodash";

// const propTypes = {
//   bsStyle: PropTypes.string,
//   children: PropTypes.node,
//   disabled: PropTypes.bool,
//   icon: PropTypes.node,
//   loading: PropTypes.bool,
//   spinColor: PropTypes.string,
//   spinAlignment: PropTypes.string
// };
interface Props extends ButtonProps {
  loading?: boolean;
}
// The spinner is drawn by spin.js, which writes its colour as an inline style on
// each line it draws, so no stylesheet rule can repaint it. That is fine for
// every button whose fill the dark theme leaves alone, but a primary button is
// filled with --dark-accent, and on the lighter variants that fill is pale
// enough that a white spinner vanishes into it. So the spinner reads the same
// token the button's own label reads. Undefined in light mode, where the
// fallback is the white that has always been correct there.
const primaryLabelColor = (): string => {
  try {
    const onAccent = getComputedStyle(document.documentElement)
      .getPropertyValue("--dark-accent-on")
      .trim();
    return onAccent || "#fff";
  } catch {
    return "#fff";
  }
};

class ButtonLoader extends Component<Props> {
  renderIcon() {
    if (!this.props.loading) {
      return null;
    }
    // Resolved here rather than above the guard: this reads computed style, and
    // every primary button would pay for it on every render otherwise, while
    // only the ones actually spinning need the answer.
    let spinColor = "#fff";
    if (this.props.color === "link") {
      spinColor = "#777";
    } else if (this.props.color === "primary") {
      spinColor = primaryLabelColor();
    }
    return <Spinner spinColor={spinColor} spinAlignment="left" />;
  }
  render() {
    const buttonDisabled = this.props.disabled || this.props.loading;

    return (
      <Button
        {..._.omit(this.props, "disabled", "loading")}
        // color={this.props.color}
        disabled={buttonDisabled}
      >
        {this.renderIcon()} {this.props.children}
      </Button>
    );
  }
}

// ButtonLoader.propTypes = propTypes;

export default ButtonLoader;

export { ButtonLoader, Spinner };
